import { styled } from '@mui/material';

const RootContainer = styled('div')(() => ({
  flexGrow: 1,
}));

const ListContainer = styled('ul')(() => ({
  overflow: 'hidden',
}));

export { RootContainer, ListContainer };
